//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Navigation from "~/components/auth/authNavigation.vue";

export default {
  components: { Navigation },
  name: 'AuthLayout'
}
